import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function forgotPasswordSuccess(draft: Draft<IAuthData>) {
  draft.forgotPassword.config.isLoading = false;
}

export default forgotPasswordSuccess;
